import { type ComponentProps, memo } from 'react';

import { Close as CloseIcon } from '@air/next-icons';
import { VisuallyHidden } from '@air/primitive-visually-hidden';
import { tailwindVariants, type VariantProps } from '@air/utils-tailwind';

export const modalCloseButton = tailwindVariants({
  base: 'flex size-6 items-center justify-center rounded-4 border-0 bg-transparent text-grey-11 outline-none hover:bg-grey-4 focus-visible:ring-2 focus-visible:ring-blue-9 active:bg-grey-4',
  defaultVariants: {
    size: 'extra-small',
  },
  variants: {
    size: {
      'extra-small': 'size-6',
      medium: 'size-8',
      small: 'size-8',
    },
  },
});

export const modalCloseButtonIcon = tailwindVariants({
  defaultVariants: {
    size: 'extra-small',
  },
  variants: {
    size: {
      'extra-small': 'size-4',
      medium: 'size-8',
      small: 'size-6',
    },
  },
});

export type ModalCloseButtonVariants = VariantProps<typeof modalCloseButton>;

export type ModalCloseButtonProps = ComponentProps<'button'> & ModalCloseButtonVariants;

export const ModalCloseButton = memo(({ className, size, type = 'button', ...restOfProps }: ModalCloseButtonProps) => {
  return (
    <button
      className={modalCloseButton({ className, size })}
      data-testid="MODAL_CLOSE_BUTTON"
      type={type}
      {...restOfProps}
    >
      <VisuallyHidden>Close modal</VisuallyHidden>
      <CloseIcon className={modalCloseButtonIcon({ size })} />
    </button>
  );
});

ModalCloseButton.displayName = 'ModalCloseButton';
